import React, { useState, useEffect } from 'react';

// "controllers"
import { ProductController } from "controllers";

// components
import { DamageReport } from 'shared/components/product';

//redux
import { useSelector } from 'react-redux';
import { selectCountry } from '../../../hyc-store/reducers/countries/countriesReducer';



const TableProductDamage = ({ lastBarcode }) => {
    const country = useSelector(selectCountry);
    const [data, setData] = useState();

    useEffect(() => {
        const fetchData = async () => {
            const result = await ProductController.getDamageProducts(country);
            setData(result);
        }

        fetchData();
    }, [lastBarcode, country]);

    return (
        <DamageReport data={data} />
    );
}

export { TableProductDamage };
